<section>
  <div class="row">
    <div class="col-12">
      <form class="needs-validation container-style" [formGroup]="formFreight">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-sm-12 col-12">
            <app-custom-audit-info [userNameCreate]="freightContract.userNameCreate"
              [createDate]="freightContract.createDate" [userNameUpdate]="freightContract.userNameUpdate"
              [updateDate]="freightContract.updateDate"
              [reserveSpace]="true"></app-custom-audit-info>
          </div>
        </div>
        <div class="row d-flex justify-content-between p-2">
          <div class="col-lg-12">
            <div class="row">
              <div class="col-lg-12 fieldset-freight">
                <p-fieldset legend="Origen">
                  <div class="d-flex flex-wrap gap-1">
                    <div class="col field-city-origin">
                      <app-custom-input-text [value]="cityOrigin" [labelText]="'Ciudad'"
                        [disabled]="true"></app-custom-input-text>
                    </div>
                    <div class="col field-department">
                      <app-custom-input-text [value]="departmentOrigin" [labelText]="'Departamento'"
                        [disabled]="true"></app-custom-input-text>
                    </div>
                  </div>
                </p-fieldset>
              </div>
              <div class="col-lg-12 fieldset-freight">
                <p-fieldset legend="Destino">
                  <div class="d-flex flex-wrap gap-1">
                    <div class="col field-city-destiny">
                      <app-custom-input-text [value]="cityDestiny" [labelText]="'Ciudad'"
                        [disabled]="true"></app-custom-input-text>
                    </div>
                    <div class="col field-department">
                      <app-custom-input-text [value]="departmentDestiny" [labelText]="'Departamento'"
                        [disabled]="true"></app-custom-input-text>
                    </div>
                    <div class="col field-sector">
                      <app-custom-input-text [value]="sectorCodeName" [labelText]="'Sector'"
                        [disabled]="true"></app-custom-input-text>
                    </div>
                  </div>
                </p-fieldset>
              </div>
              <div class="col field-concept">
                <app-custom-select formControlName="conceptId" [labelText]="'Tipo Vehículo'" [list]="listConcepts"
                  [required]="true" [recovery]="true" (onChangeSelect)="getConcept($event)">
                </app-custom-select>
              </div>
              <div class="col field-value">
                <app-custom-input-decimal formControlName="value" [labelText]="'Valor'"
                  [required]="true"></app-custom-input-decimal>
              </div>
              <div class="col field-buttons">
                <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'primary'"
                  [disabled]="disabledForm" [variant]="undefined" (onClick)="send()">
                </app-custom-button>
              </div>
            </div>
          </div>
        </div>
      </form>
      <section class="row mt-2">
        <div class="container-style mx-0">
          <div class="col-lg-12">
            <app-custom-table [headers]="header" [data]="data" [actions]="tableActions" [showRecover]="!disabledForm"
              (onPageChange)="onPageChange($event)" (onRecoverData)="getFreightByConstructionSite()"
              (onAction)="onAction($event)">
            </app-custom-table>
          </div>
        </div>
      </section>
    </div>
  </div>
</section>